import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import ProductTaxModel from "../../models/masters/producttax-model";

const url = getEndPoint(API_END_POINT.PRODUCT) +"/api/ProductTax/GetAllProductTax";// //{/api/Block/GetAllBlock}`)  //// "https://localhost:7054/api/Block/GetAllBlock";
export const useGetProductTax = createQuery<
ProductTaxModel[],
  null,
  AxiosError
>({
  queryKey: ["keyProductTaxlist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
